import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Wapi: Unofficial Whatsapp Business Api</title>
        <meta
          name="description"
          content="Wapi is an unofficial WhatsApp Business API, It aims to provide an alternative solution for businesses looking to integrate WhatsApp's messaging capabilities into their operations"
        />
        <meta
          property="og:title"
          content="Wapi: Unofficial Whatsapp Business Api"
        />
        <meta
          property="og:description"
          content="Wapi is an unofficial WhatsApp Business API, It aims to provide an alternative solution for businesses looking to integrate WhatsApp's messaging capabilities into their operations"
        />
      </Helmet>
      <header data-thq="thq-navbar" className="home-navbar-interactive">
        <h1 className="home-text">Wapi</h1>
        <div
          data-thq="thq-navbar-nav"
          data-role="Nav"
          className="home-desktop-menu"
        >
          <nav
            data-thq="thq-navbar-nav-links"
            data-role="Nav"
            className="home-nav"
          >
            <a href="/#features" className="home-link">
              Features
            </a>
            <a href="/#pricing" className="home-link1">
              Pricing
            </a>
            <Link to="/docs" className="home-navlink">
              Docs
            </Link>
          </nav>
        </div>
        <div data-thq="thq-navbar-btn-group" className="home-btn-group">
          <Link to="/login" className="home-login button">
            Login
          </Link>
          <Link to="/signup" className="home-register button">
            Start Free Trial
          </Link>
        </div>
        <div data-thq="thq-burger-menu" className="home-burger-menu">
          <svg viewBox="0 0 1024 1024" className="home-icon">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="home-mobile-menu">
          <div
            data-thq="thq-mobile-menu-nav"
            data-role="Nav"
            className="home-nav1"
          >
            <div className="home-container01">
              <h2>Wapi</h2>
              <div data-thq="thq-close-menu" className="home-menu-close">
                <svg viewBox="0 0 1024 1024" className="home-icon2">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav
              data-thq="thq-mobile-menu-nav-links"
              data-role="Nav"
              className="home-nav2"
            ></nav>
            <div className="home-container02">
              <a
                href="/login"
                target="_blank"
                rel="noreferrer noopener"
                className="home-login1 button"
              >
                Login
              </a>
              <a
                href="/signup"
                target="_blank"
                rel="noreferrer noopener"
                className="home-register1 button"
              >
                Get Started For Free
              </a>
            </div>
          </div>
        </div>
      </header>
      <div className="home-container03">
        <div className="home-container04">
          <h3 className="home-text02">
            <span>Explore Our Api Documentation </span>
            <br></br>
          </h3>
        </div>
        <div className="home-container05">
          <Link to="/docs" className="home-navlink1 button">
            Try it out
          </Link>
          <button type="button" className="home-button button">
            Download Postman Collection
          </button>
        </div>
        <div className="home-container06">
          <img
            alt="image"
            src="/external/wapi_postman-1500w.jpg"
            className="home-image"
          />
        </div>
      </div>
      <div id="pricing" className="home-container07">
        <div className="home-container08">
          <h1>Pricing Plan</h1>
          <span className="home-text06">
            <span>
              Wapi has Only one pricing option which is charged per each
              whatsapp account connected
            </span>
            <br></br>
            <br></br>
            <span>
              You can also try out our api for three days [No Credit Card
              required]
            </span>
            <br></br>
            <span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
            <span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </span>
          <a
            href="/signup"
            target="_blank"
            rel="noreferrer noopener"
            className="home-link2"
          >
            Start 3 Days Free Trial 
          </a>
        </div>
        <div className="home-container09">
          <div className="home-container10">
            <span className="home-text18">Single</span>
            <span className="home-text19">$20</span>
            <span className="home-text20">
              <span className="home-text21">1</span>
              <span> Whatsapp account</span>
            </span>
            <span className="home-text23">
              <span className="home-text24">Unlimited</span>
              <span> messages/month</span>
            </span>
            <span className="home-text26">
              <span className="home-text27">Free</span>
              <span> Dialogflow Integration</span>
            </span>
            <span className="home-text29">
              <span className="home-text30">Media</span>
              <span> messages</span>
            </span>
            <span className="home-text32">
              <span className="home-text33">24/7</span>
              <span> Support</span>
            </span>
            <a
              href="/signup"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link3 button"
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
      <div id="features" className="home-hero">
        <div className="home-container11">
          <h3 className="home-text35">Features</h3>
        </div>
        <h3 className="home-text36">
          <span>✅ Send text messages</span>
          <br></br>
        </h3>
        <h3 className="home-text39">
          <span>✅ Send media messages</span>
          <br></br>
        </h3>
        <h3 className="home-text42">
          <span>✅ Receive messages (through webhook)</span>
          <br></br>
        </h3>
        <h3 className="home-text45">
          <span>✅ Send typing state</span>
          <br></br>
        </h3>
        <h3 className="home-text48">
          <span>✅ Send seen state</span>
          <br></br>
        </h3>
        <h3 className="home-text51">
          <span>✅ Send recording state</span>
          <br></br>
        </h3>
        <h3 className="home-text54">
          <span>✅ React to messages</span>
          <br></br>
        </h3>
        <h3 className="home-text57">
          <span>✅ Delete messages</span>
          <br></br>
        </h3>
        <h3 className="home-text60">
          <span>✅ Reply to messages</span>
          <br></br>
        </h3>
        <h3 className="home-text63">
          <span>
            ✅ Free Dialogflow Integration
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
        </h3>
      </div>
      <footer className="home-footer">
        <div className="home-container12">
          <span className="home-text66">Email us at </span>
          <a
            href="mailto:admin@steksolutions.net?subject="
            className="home-link4"
          >
            admin@steksolutions.net
          </a>
        </div>
        <div className="home-separator"></div>
        <span className="home-text67">© 2023 Wapi, All Rights Reserved.</span>
      </footer>
    </div>
  )
}

export default Home
